import { render, staticRenderFns } from "./FilterColumnDataTable.vue?vue&type=template&id=5f4f6496&scoped=true"
import script from "./FilterColumnDataTable.vue?vue&type=script&lang=js"
export * from "./FilterColumnDataTable.vue?vue&type=script&lang=js"
import style0 from "./FilterColumnDataTable.vue?vue&type=style&index=0&id=5f4f6496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f6496",
  null
  
)

export default component.exports